import alton from 'typography-theme-alton'
import bootstrap from 'typography-theme-bootstrap'
import deYoung from 'typography-theme-de-young'
import doelger from 'typography-theme-doelger'
import elkGlen from 'typography-theme-elk-glen'
import fairyGates from 'typography-theme-fairy-gates'
import funston from 'typography-theme-funston'
import github from 'typography-theme-github'
import grandView from 'typography-theme-grand-view'
import irving from 'typography-theme-irving'
import judah from 'typography-theme-judah'
import lawton from 'typography-theme-lawton'
import legible from 'typography-theme-legible'
import lincoln from 'typography-theme-lincoln'
import kirkham from 'typography-theme-kirkham'
import moraga from 'typography-theme-moraga'
import noriega from 'typography-theme-noriega'
import oceanBeach from 'typography-theme-ocean-beach'
import parnassus from 'typography-theme-parnassus'
import stardust from 'typography-theme-stardust'
import stAnnes from 'typography-theme-st-annes'
import sternGrove from 'typography-theme-stern-grove'
import stowLake from 'typography-theme-stow-lake'
import sutro from 'typography-theme-sutro'
import twinPeaks from 'typography-theme-twin-peaks'
import usWebStandards from 'typography-theme-us-web-design-standards'
import wikipedia from 'typography-theme-wikipedia'
import kubrick from 'typography-theme-wordpress-kubrick'
import wp2010 from 'typography-theme-wordpress-2010'
import wp2011 from 'typography-theme-wordpress-2011'
import wp2012 from 'typography-theme-wordpress-2012'
import wp2013 from 'typography-theme-wordpress-2013'
import wp2014 from 'typography-theme-wordpress-2014'
import wp2015 from 'typography-theme-wordpress-2015'
import wp2016 from 'typography-theme-wordpress-2016'
import trajan from 'typography-theme-trajan'
import zacklive from 'typography-theme-zacklive'
import anonymous from 'typography-theme-anonymous'

export const themes = {
  // jxnblk,
  alton,
  bootstrap,
  deYoung,
  doelger,
  elkGlen,
  fairyGates,
  funston,
  github,
  grandView,
  irving,
  judah,
  lawton,
  legible,
  lincoln,
  kirkham,
  moraga,
  noriega,
  oceanBeach,
  parnassus,
  stardust,
  stAnnes,
  sternGrove,
  stowLake,
  sutro,
  twinPeaks,
  usWebStandards,
  wikipedia,
  kubrick,
  wp2010,
  wp2011,
  wp2012,
  wp2013,
  wp2014,
  wp2015,
  wp2016,
  trajan,
  zacklive,
  anonymous,
}

export default themes
